/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
'use strict';

class Ampliacion {
  constructor($scope, Util, Proyecto, Modal, _, DataService, Message, $http,subDomain, baseUrl) {
    'ngInject';
    this.$http = $http;
    this.$scope = $scope;
    this.Util = Util;
    this.Proyecto = Proyecto;
    this.Modal = Modal;
    this._ = _;
    this.archivos = null;
    this.DataService = DataService;
    this.Message = Message;
    this.qrimage = null;
    this.subDomain = subDomain;
    this.baseUrl = baseUrl;
  }

  $onInit() {
    this.tipos_plazo_ampliado = [{
      codigo: 'adenda_cierre',
      nombre: 'Adenda'
    }];
    this.plazo_cierre = [];
    setTimeout(()=>{
      if (!this.proyecto.cierre.ampliacion){
        this.proyecto.cierre.ampliacion = {}
        this.proyecto.cierre.ampliacion.cierre = [];    
      }
      for (let i in this.proyecto.cierre.ampliacion.cierre) {
        this.calcularPlazos(i);
      }
      
    },2000)
   
  }

  

  adicionar(value){
    // console.log("ADICIONAR AMPLIACION",value)
    if (!value) {
      // console.log("no tiene valor")
      value=[];
    }
    // for(let i in value){
    //   // console.log(value[i].id_avance_fisico,"<<")
    //   if (!value[i].plazo || value[i].edicion) {
    //     // console.log(value[i].id_avance_fisico, value[i].edicion)
    //     this.Message.warning(`Debe guardar el registro antes de crear otro`);
    //     return;
    //   }
    // }
    value.push({edicion: true})

  }
  guardar(){
    this.DataService.post(`proyectos/cie`, this.proyecto)
      .then(response=>{
        if (response) {
          
          this.Message.success("Actualizado correctamente.");
        }
      })
    //  value.edicion = false;
  }

  eliminar(value,index){
    this.proyecto.cierre.ampliacion.cierre.splice(index, 1);
    this.plazo_cierre.splice(index,1);
  }


  calcularPlazos(key){

        if(key == 0){
          this.plazo_cierre[key] = new Date(this.proyecto.cierre.fecha_inicio);
      
          this.plazo_cierre[key].setDate(this.plazo_cierre[key].getDate() + parseInt(this.proyecto.cierre.plazo_cierre)+ parseInt(this.proyecto.cierre.ampliacion.cierre[key].plazo))
          this.plazo_cierre[key] = this.plazo_cierre[key].toISOString();  

        }
        if(key >= 1){
          this.plazo_cierre[key] = new Date(this.plazo_cierre[key-1]);
          this.plazo_cierre[key].setDate(this.plazo_cierre[key].getDate() + parseInt(this.proyecto.cierre.ampliacion.cierre[key].plazo))
          this.plazo_cierre[key] = this.plazo_cierre[key].toISOString();
        }
        // console.log("plazo_cierre["+key+"] : ", this.plazo_cierre[key])
      
      

       
  }

}

export default Ampliacion;



// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/ampliacion/ampliacion.controller.js